import * as React from 'react';

export function IconSunshine(): JSX.Element {
    return (
        <svg xmlns="http://www.w3.org/2000/svg"
             width="34"
             height="34"
             viewBox="0 0 34 34">
            <circle cx="16.994"
                    cy="17.005"
                    r="5.667"
                    fill="#f7c300"/>
            <line x1="16.997"
                  y1="5.673"
                  x2="16.997"
                  y2="9.424"
                  fill="none"
                  stroke="#f7c300"
                  strokeLinecap="round"
                  strokeLinejoin="round"/>
            <line x1="16.997"
                  y1="28.339"
                  x2="16.997"
                  y2="24.588"
                  fill="none"
                  stroke="#f7c300"
                  strokeLinecap="round"
                  strokeLinejoin="round"/>
            <line x1="28.328"
                  y1="17"
                  x2="24.576"
                  y2="17"
                  fill="none"
                  stroke="#f7c300"
                  strokeLinecap="round"
                  strokeLinejoin="round"/>
            <line x1="5.661"
                  y1="17"
                  x2="9.412"
                  y2="17"
                  fill="none"
                  stroke="#f7c300"
                  strokeLinecap="round"
                  strokeLinejoin="round"/>
            <line x1="25.001"
                  y1="8.986"
                  x2="22.348"
                  y2="11.639"
                  fill="none"
                  stroke="#f7c300"
                  strokeLinecap="round"
                  strokeLinejoin="round"/>
            <line x1="8.973"
                  y1="25.014"
                  x2="11.625"
                  y2="22.361"
                  fill="none"
                  stroke="#f7c300"
                  strokeLinecap="round"
                  strokeLinejoin="round"/>
            <line x1="8.972"
                  y1="8.995"
                  x2="11.625"
                  y2="11.648"
                  fill="none"
                  stroke="#f7c300"
                  strokeLinecap="round"
                  strokeLinejoin="round"/>
            <line x1="25"
                  y1="25.023"
                  x2="22.347"
                  y2="22.371"
                  fill="none"
                  stroke="#f7c300"
                  strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    );
}
